export var makeTypography = function makeTypography() {
  var typography = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fontSize = typography.fontSize || 14;
  var htmlFontSize = typography.htmlFontSize || 16;
  var factor = fontSize / 14;
  return Object.assign(Object.assign({}, typography), {
    fontFamily: typography.fontFamily || 'Roboto, sans-serif',
    fontSize: fontSize,
    htmlFontSize: htmlFontSize,
    pixelToRem: function pixelToRem(size) {
      if (size === 0) {
        return '0';
      }

      if (typeof size === 'string') {
        return size;
      }

      return "".concat(size / htmlFontSize * factor, "rem");
    }
  });
};